import { useMediaQuery } from "@mui/material";
import type { FormInstance } from "antd";
import { maybeSubmitFiltersOnChange } from "./filterSubmitMode";

const MOBILE_FILTER_BREAKPOINT = "(max-width: 768px)";

/**
 * Returns an onChange handler that no-ops unless FILTER_AUTO_SUBMIT_ON_CHANGE
 * is true (legacy desktop auto-submit).
 */
export function useFilterAutoSubmitOnChange(formInstance: FormInstance) {
  const isMobile = useMediaQuery(MOBILE_FILTER_BREAKPOINT);

  return () =>
    maybeSubmitFiltersOnChange(() => formInstance.submit(), { isMobile });
}
